import { AppBar, Box, Toolbar, Container, Breakpoint } from '@mui/material';
import styled, { css } from 'styled-components';

const StyledAppBar = styled(AppBar) <{ $borderBottom: boolean }>`
  box-shadow: none !important;

  ${props =>
    props.$borderBottom &&
    css`
      border-bottom: 1px solid ${props.theme.palette.grey[200]};
    `}
`;

const StyledBox = styled(Box) <{ $logoOnly: boolean }>`
  display: flex;
  justify-content: space-between;

  ${props =>
    props.$logoOnly &&
    css`
      justify-content: center;
    `}
`;

export interface PageHeaderLayoutProps {
  children: React.ReactNode;
  logoOnly?: boolean;
  maxWidth?: Breakpoint;
  borderBottom?: boolean;
  // eslint-disable-next-line react/no-unused-prop-types
  dvLogoFilepath?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  disabled?: boolean;
}

export const PageHeaderLayout = ({
  children,
  logoOnly = false,
  maxWidth = 'lg',
  borderBottom = false,
}: PageHeaderLayoutProps) => {
  return (
    <>
      <StyledAppBar sx={{ backgroundColor: '#fff' }} position="fixed" $borderBottom={borderBottom}>
        <Toolbar>
          <Container maxWidth={maxWidth}>
            <StyledBox $logoOnly={logoOnly}>{children}</StyledBox>
          </Container>
        </Toolbar>
      </StyledAppBar>

      {/* Reason:  https://mui.com/material-ui/react-app-bar/#fixed-placement */}
      <Toolbar />
    </>
  );
};
